import script from "./RouteNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteNavigator.vue?vue&type=script&setup=true&lang=js"

import "./RouteNavigator.vue?vue&type=style&index=0&id=7452bb7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7452bb7c"]])

export default __exports__